import { render } from "./Complaint_Procedures.vue?vue&type=template&id=01c14e0a"
import script from "./Complaint_Procedures.vue?vue&type=script&lang=js"
export * from "./Complaint_Procedures.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__